/* eslint-disable no-unused-vars */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import OddButton from "../OddButton/oddbutton";
import BetPlacing from "../BetPlacing/BetPlacing";
import { connectSportMarketStandard } from "./SportMarketStandard.connect";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrencyFormat,
  getCurrencyFormatRoundedOff,
} from "../../helpers/getCurrencyFormat.helper";
import SVG_StopWatchtIcon from "../../assets/images/svgs/stopwatch-timer.svg?react";
import SVG_LadderIcon from "../../assets/images/svgs/ladder.svg?react";
import { UNICON_THEME } from "../../config/api.config";

const SportMarketStandard = ({
  data,
  betPlacing,
  exposure,
  exposureFancy,
  actions,
  isRacing = false,
  showHeader = true,
  elementsParams,
  openBets,
  cashoutPopUp,
  sportLimits,
  selectedRaces = [],
  setSelectedRaces,
}) => {
  // const dispatch = useDispatch();
  const [cashOutData, setCashData] = useState(0);


  const isFancy = data?.fancy_id;
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth;

  const [clicked, setClicked] = useState(null);

  const calculateExposure = (runnerId) => {
    let number = 0,
      calced;
    // const isFancy = data.mtype == "INNINGS_RUNS" && data.btype == "LINE"
    const pnlId = data.market_id;
    if (exposure && exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId
      );
      number = findNumber[0].user_pl;
    }
    if (betPlacing.market === data.market_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          // const profit = isFancy ? (betPlacing.stake * betPlacing.priceActual / 100).toFixed(2) : (betPlacing.stake * betPlacing.priceActual - betPlacing.stake).toFixed(2)
          const profit = isFancy
            ? betPlacing.stake
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
        // calced = number - Number(betPlacing.stake)
      }
    }
    if (number) return number;
  };

  const cashOut = (market) => {
    let greenAmount = 0;
    let redAmount = 0;
    let currentlaygrrenodds = 0;
    let runners;
    let runners_point = [];
    for (var i = 0; i < market?.runners?.length; i++) {
      if (
        calculateExposure(market.runners[0].selectionId) > 0 &&
        calculateExposure(market.runners[1].selectionId) > 0
      ) {
        if (
          calculateExposure(market.runners[0].selectionId) >
          calculateExposure(market.runners[1].selectionId)
        ) {
          greenAmount = calculateExposure(market.runners[0].selectionId);
          currentlaygrrenodds = market.runners[0]?.ex?.availableToLay[0]?.price;
          runners = market.runners[0];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market.runners[1].selectionId);
          runners_point.push(redAmount);
        } else {
          greenAmount = calculateExposure(market.runners[1].selectionId);
          currentlaygrrenodds = market.runners[1]?.ex?.availableToLay[0]?.price;
          runners = market.runners[1];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market.runners[0].selectionId);
          runners_point.push(redAmount);
        }
      } else {
        if (calculateExposure(market.runners[i].selectionId) >= 0) {
          greenAmount = calculateExposure(market.runners[i].selectionId);
          currentlaygrrenodds = market.runners[i]?.ex?.availableToLay[0]?.price;
          runners = market.runners[i];
          runners_point.push(greenAmount);
        } else {
          redAmount = calculateExposure(market.runners[i].selectionId);
          runners_point.push(redAmount);
        }
      }
    }

    let layStake = (greenAmount - redAmount) / currentlaygrrenodds;

    if (!runners) {
      if (Math.trunc(runners_point[0]) == Math.trunc(runners_point[1])) {
        return;
      }
      if (runners_point[0] > runners_point[1]) {
        runners = market.runners[0];
        greenAmount = calculateExposure(market.runners[0].selectionId);
        currentlaygrrenodds = market.runners[0]?.ex?.availableToLay[0]?.price;
        redAmount = calculateExposure(market.runners[1].selectionId);
      } else {
        runners = market.runners[1];
        greenAmount = calculateExposure(market.runners[1].selectionId);
        currentlaygrrenodds = market.runners[1]?.ex?.availableToLay[1]?.price;
        redAmount = calculateExposure(market.runners[0].selectionId);
      }
    }

    if (layStake === Infinity) {
      layStake = (greenAmount - redAmount) / currentlaygrrenodds;
    }

    actions.setMarket(market.market_id);
    actions.setRunner(runners.selectionId);
    actions.setRunnerName(runners.name);
    actions.setEventName(market && market.market_name);
    actions.setIsBack(false);
    actions.setPrice(runners.ex.availableToLay[0].price);
    actions.setPriceActual(runners.ex.availableToLay[0].price);
    actions.setLine(isFancy);
    actions.setStake(Math.floor(layStake));
  };

  const sendCahsOutRequest = (marketId, delay) => {
    cashOut(marketId);
    actions.setDelay(delay);
    // actions.setCashOutId(marketId.marketId)
    // actions.setIsCashOut(true)
    // actions.setBetPlacingPopoverStage(false)
    // actions.setShowBetPlacingPopover(true)
    actions.setIsCashOutPopup({ isOpen: true, market: marketId });
  };

  const compareNumbers = (num0, num1) => {
    if (num0 > num1) {
      return 1;
    } else if (num0 < num1) {
      return 0;
    }
  };

  const cashOutShown = async (market) => {
    let greenAmount = 0;
    let redAmount = 0;
    let currentlaygrrenodds = 0;
    let runners;
    let runners_point = [];
    for (var i = 0; i < market?.runners?.length; i++) {
      if (
        calculateExposure(market?.runners[0]?.selectionId) > 0 &&
        calculateExposure(market?.runners[1]?.selectionId) > 0
      ) {
        if (
          calculateExposure(market?.runners[0]?.selectionId) >
          calculateExposure(market?.runners[1]?.selectionId)
        ) {
          greenAmount = calculateExposure(market?.runners[0]?.selectionId);
          currentlaygrrenodds =
            market?.runners[0]?.ex?.availableToLay[0]?.price;
          runners = market?.runners[0];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market?.runners[1]?.selectionId);
          runners_point.push(redAmount);
        } else {
          greenAmount = calculateExposure(market?.runners[1]?.selectionId);
          currentlaygrrenodds =
            market?.runners[1]?.ex?.availableToLay[0]?.price;
          runners = market?.runners[1];
          runners_point.push(greenAmount);
          redAmount = calculateExposure(market?.runners[0]?.selectionId);
          runners_point.push(redAmount);
        }
      } else {
        if (calculateExposure(market?.runners[i].selectionId) >= 0) {
          greenAmount = calculateExposure(market?.runners[i]?.selectionId);
          currentlaygrrenodds =
            market?.runners[i]?.ex?.availableToLay[0]?.price;
          runners = market?.runners[i];
          runners_point.push(greenAmount);
        } else {
          redAmount = calculateExposure(market?.runners[i]?.selectionId);
          runners_point.push(redAmount);
        }
      }
    }

    let layStake = (greenAmount - redAmount) / currentlaygrrenodds;

    if (!runners) {
      if (Math?.trunc(runners_point[0]) == Math?.trunc(runners_point[1])) {
        return;
      }
      if (runners_point[0] > runners_point[1]) {
        runners = market?.runners[0];
        greenAmount = calculateExposure(market?.runners[0].selectionId);
        currentlaygrrenodds = market?.runners[0]?.ex?.availableToLay[0]?.price;
        redAmount = calculateExposure(market?.runners[1].selectionId);
      } else {
        runners = market?.runners[1];
        greenAmount = calculateExposure(market?.runners[1].selectionId);
        currentlaygrrenodds = market?.runners[1]?.ex?.availableToLay[1]?.price;
        redAmount = calculateExposure(market?.runners[0].selectionId);
      }
    }

    if (layStake === Infinity) {
      layStake = (greenAmount - redAmount) / currentlaygrrenodds;
    }

    const betData = {
      market: market?.market_id,
      runner: runners?.selectionId,
      isBack: false,
      stake: Math.floor(layStake),
      priceActual: runners?.ex?.availableToLay[0]?.price,
    };
    return betData;
  };

  const cashoutExposure = async (runnerId, isIndex) => {
    let betPlacingData = await cashOutShown(data);

    let number = 0,
      calced;
    const pnlId = data.market_id;
    if (exposure && exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId
      );
      number = findNumber[0].user_pl;
    }
    if (betPlacingData.market === data.market_id) {
      if (betPlacingData.runner === runnerId) {
        if (betPlacingData.isBack) {
          const profit = isFancy
            ? betPlacingData.stake
            : (
                betPlacingData.stake * betPlacingData.priceActual -
                betPlacingData.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacingData.stake * (betPlacingData.priceActual / 100)
            : (
                betPlacingData.stake * betPlacingData.priceActual -
                betPlacingData.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacingData.isBack
          ? number - Number(betPlacingData.stake)
          : number - Number(betPlacingData.stake) * -1;
      }
    }
    if (calced && isIndex) return calced;
    if (number) return number;
  };

  useEffect(() => {
    const getCashoutData = async () => {
      let cashoutValue = await calculateprofiltlossCashout(data);
      setCashData(Math.floor(cashoutValue));
    };
    data?.runners?.length === 2 &&
      data?.market_type === "MATCH_ODDS" &&
      getCashoutData();
  }, [data]);

  const calculateprofiltlossCashout = async (market) => {
    if (market?.runners?.length !== 2) {
      return 0;
    }
    let firstRunner = await cashoutExposure(market?.runners[0]?.selectionId);
    let secondRunner = await cashoutExposure(market?.runners[1]?.selectionId);
    if (Math.floor(firstRunner) === Math.floor(secondRunner)) {
      return 0;
    }

    let findindex = compareNumbers(firstRunner, secondRunner);
    let indexRunner = await cashoutExposure(
      market?.runners[findindex]?.selectionId,
      true
    );
    if (indexRunner) {
      return indexRunner;
    } else {
      return 0;
    }
  };

  const addMarketData = (market) => {
    // Check if market_id already exists in state
    const marketExists = selectedRaces.some(
      (item) => item.selectionId === market.selectionId
    );

    if (
      !marketExists &&
      selectedRaces.length < 4 &&
      data?.status !== "SUSPENDED" &&
      market?.status === "ACTIVE"
    ) {
      // If it doesn't exist, add the new data to the array
      setSelectedRaces &&
        setSelectedRaces((prevMarkets) => [
          ...prevMarkets,
          {
            ...market,
            match_id: data.match_id,
            match_name: data.match_name,
            match_date: data.match_date,
            market_id: data.market_id,
            name: data.name,
            market_name: data.market_name,
            market_type: data.market_type,
          },
        ]);
    } else {
      setSelectedRaces &&
        setSelectedRaces((prevMarkets) =>
          prevMarkets.filter((item) => item.selectionId !== market.selectionId)
        );
      // console.log("Market with this market_id already exists.", market);
    }
  };

  const renderOdds = (item, runner) => {
    const status = isFancy
      ? item?.is_active === 1
        ? "OPEN"
        : "SUSPENDED"
      : item?.status != "ACTIVE" || data?.status != "OPEN"
      ? "SUSPENDED"
      : "OPEN";

    const transformData = (data) => {
      const result = {};

      for (let i = 2; i >= 0; i--) {
        if (!!data?.ex?.availableToBack) {
          result[`back${i}`] = {
            price: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.price,
            oprice: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.oprice,
            size: data?.ex?.availableToBack[`${i < 0 ? "" : i}`]?.size,
          };
        } else {
          result[`back${i}`] = {
            price: undefined,
            oprice: undefined,
            size: undefined,
          };
        }

        if (!!data?.ex?.availableToLay) {
          result[`lay${i}`] = {
            price: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.price,
            oprice: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.oprice,
            size: data?.ex?.availableToLay[`${i < 0 ? "" : i}`]?.size,
          };
        } else {
          result[`lay${i}`] = {
            price: undefined,
            oprice: undefined,
            size: undefined,
          };
        }
      }

      return result;
    };

    // if (!isFancy && (data?.marketType === 'MATCH_ODDS' || data?.marketType == 'Special')) {
    if (!isFancy) {
      if (status && status?.localeCompare("OPEN")) {
        return (
          <span className=" col-span-6 text-center min-h-12 py-[1px] px-[1px]">
            <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
              {isRacing && item?.status && item?.status != "ACTIVE"
                ? item?.status?.toUpperCase()
                : status?.toUpperCase()}
            </span>
          </span>
        );
      }

      const matchOddData = transformData(item);

      return (
        <>
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={true}
                oddData={{ ...matchOddData?.back2, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={2}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
              />
            </span>
          }
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={true}
                oddData={{ ...matchOddData?.back1, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={1}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
              />
            </span>
          }

          <span className=" text-center min-h-12">
            <OddButton
              market={data}
              isBack={true}
              oddData={{ ...matchOddData?.back0, runner }}
              showEmpty
              centered
              showBlock={isRacing ? true : false}
              marketNum={0}
              setClicked={setClicked}
              clicked={clicked}
              isInactive={!!status?.localeCompare("OPEN")}
            />
          </span>

          <span className=" text-center min-h-12">
            <OddButton
              market={data}
              isBack={false}
              oddData={{ ...matchOddData?.lay0, runner }}
              showEmpty
              centered
              showBlock={isRacing ? true : false}
              marketNum={0}
              setClicked={setClicked}
              clicked={clicked}
              isInactive={!!status?.localeCompare("OPEN")}
            />
          </span>
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={false}
                oddData={{ ...matchOddData?.lay1, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={1}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
              />
            </span>
          }
          {
            <span className="hidden md:block text-center min-h-12">
              <OddButton
                market={data}
                isBack={false}
                oddData={{ ...matchOddData?.lay2, runner }}
                showEmpty
                centered
                showBlock={isRacing ? true : false}
                mainBlock={false}
                marketNum={2}
                setClicked={setClicked}
                clicked={clicked}
                isInactive={
                  data?.market_type != "MATCH_ODDS" ||
                  !!status?.localeCompare("OPEN")
                }
              />
            </span>
          }
        </>
      );
    }

    if (status && !!status?.localeCompare("OPEN")) {
      return (
        <span className=" col-span-4 text-center min-h-12 py-[1px] px-[1px]">
          <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
            {status?.toUpperCase()}
          </span>
        </span>
      );
    }

    return (
      <>
        {isFancy && (
          <span className=" text-center min-h-12 cols-span-1 md:col-span-2">
            <OddButton
              market={isFancy ? item : data}
              isBack={item?.category === 6 ? true : false}
              oddData={{ ...item, runner }}
              showEmpty
              centered
              isFancy={isFancy}
            />
          </span>
        )}
        <span className=" text-center min-h-12 cols-span-1 md:col-span-2">
          <OddButton
            market={isFancy ? item : data}
            isBack={true}
            oddData={{ ...item, runner }}
            showEmpty
            centered
            isFancy={isFancy}
          />
        </span>
      </>
    );
  };

  const openLadder = (name, id) => {
    if (exposureFancy && exposureFancy[id]) {
      actions.setSportLadderShow(true);
      actions.setSportLadderTitle(name);
      actions.setSportLadderId(id);
      actions.requestSportLadder(id);
    }
  };

  const renderExposure = (runnerId, item, index) => {
    let number = 0,
      calced;
    // const isFancy = data.mtype == "INNINGS_RUNS" && data.btype == "LINE"
    const pnlId = data.market_id;
    if (exposure && exposure && exposure[pnlId]) {
      let findNumber = exposure[pnlId]?.filter(
        (item) => item.selection_id == runnerId
      );
      number = findNumber[0]?.user_pl;
    }

    let odds =
      data?.market_type === "BOOKMAKER"
        ? betPlacing.priceActual / 100 + 1
        : betPlacing.priceActual;
    if (betPlacing.market === data.market_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          // const profit = isFancy ? (betPlacing.stake * betPlacing.priceActual / 100).toFixed(2) : (betPlacing.stake * betPlacing.priceActual - betPlacing.stake).toFixed(2)
          const profit = isFancy
            ? betPlacing.stake
            : (betPlacing.stake * odds - betPlacing.stake).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (betPlacing.stake * odds - betPlacing.stake).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
        // calced = number - Number(betPlacing.stake)
      }
    }

    const preCalced =
      isFancy && number == 0 ? (
        <span className="text-[12px] font-bold from-neutral-600">
          Max exposure:{" "}
        </span>
      ) : (
        ""
      );

    if (number || calced)
      return (
        <div className=" w-full flex items-center">
          {number ? (
            <div
              className={`text-[12px] font-bold ${
                number > 0 ? "text-text_Success" : "text-text_Danger"
              } whitespace-nowrap`}
            >
              {getCurrencyFormatRoundedOff(number)}
            </div>
          ) : null}
          {preCalced}
          {(calced || (number && calced == 0)) && (
            <div
              className={`text-[12px] font-bold ${
                calced > 0 ? "text-text_Success" : "text-text_Danger"
              }`}
            >
              &nbsp; &gt;&gt; {getCurrencyFormatRoundedOff(calced)}
            </div>
          )}
        </div>
      );

    return <span className="text-[12px] font-bold text-text_Success"></span>;
  };

  const renderExposureFancy = (runnerId) => {
    let number = 0,
      calced;
    // const isFancy = data.mtype == "INNINGS_RUNS" && data.btype == "LINE"
    const pnlId = data.fancy_id;
    if (exposureFancy && exposureFancy[pnlId]) number = exposureFancy[pnlId];
    if (betPlacing.market === data.fancy_id) {
      if (betPlacing.runner === runnerId) {
        if (betPlacing.isBack) {
          // const profit = isFancy ? (betPlacing.stake * betPlacing.priceActual / 100).toFixed(2) : (betPlacing.stake * betPlacing.priceActual - betPlacing.stake).toFixed(2)
          const profit = isFancy
            ? betPlacing.stake
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * (isFancy ? -1 : 1);
        } else {
          const profit = isFancy
            ? betPlacing.stake * (betPlacing.priceActual / 100)
            : (
                betPlacing.stake * betPlacing.priceActual -
                betPlacing.stake
              ).toFixed(2);
          calced = (isFancy ? 0 : number) + Number(profit) * -1;
        }
      } else {
        calced = betPlacing.isBack
          ? number - Number(betPlacing.stake)
          : number - Number(betPlacing.stake) * -1;
      }
    }

    const preCalced =
      isFancy && number == 0 ? (
        <span className="text-[12px] font-bold from-neutral-600">
          Max exposure:{" "}
        </span>
      ) : (
        ""
      );

    if (number || calced)
      return (
        <div className=" w-full flex items-center">
          {number ? (
            <div
              className={`text-[12px] font-bold ${
                number > 0 ? "text-text_Success" : "text-text_Danger"
              } whitespace-nowrap`}
            >
              {getCurrencyFormatRoundedOff(number)}
            </div>
          ) : null}
          {preCalced}
          {(calced || (number && calced == 0)) && (
            <div
              className={`text-[12px] font-bold ${
                calced > 0 ? "text-text_Success" : "text-text_Danger"
              }`}
            >
              &nbsp; &gt;&gt; {getCurrencyFormatRoundedOff(calced)}
            </div>
          )}
        </div>
      );
    return <span className="text-[12px] font-bold text-text_Success"></span>;
  };

  // const history = useHistory();
  // const location = useLocation();
  // const navigate = useNavigate();

  // const eventTypeId = location?.pathname?.split("/")[2];
  // const eventId = history?.location?.pathname?.split("/")[3];
  // end get eventTypeId

  // const [activeIcon, setActiveIcon] = useState();
  const favoritesState = useSelector((state) => state.favorites);

  localStorage.setItem("favorites", JSON.stringify(favoritesState));

  // const isFavorite = () => {
  //   if (
  //     favoritesState?.favoritesAll?.length > 0 &&
  //     data &&
  //     favoritesState?.favoritesAll?.filter(
  //       (el) =>
  //         el?._id === data?._id &&
  //         (el?.marketId === data?.marketId ||
  //           el?.marketBook?.marketId === data?.marketId)
  //     ).length
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  // useEffect(() => {
  //   if (isFavorite()) {
  //     setActiveIcon(true);
  //   } else setActiveIcon(false);
  // }, [favoritesState, data]);

  const renderFancy = (item) => {
    const runner = {
      id: item?.fancy_id,
      name: item?.fancy_name,
      status: item?.GameStatus
        ? item?.GameStatus
        : item?.is_active !== 1
        ? "SUSPENDED"
        : "OPEN",
    };

    const status = item?.GameStatus
      ? item?.GameStatus
      : item?.is_active !== 1
      ? "SUSPENDED"
      : "OPEN";

    return (
      <div
        key={`${item?.id}`}
        id={item?.id}
        className={`grid grid-cols-12  ${
          !isFancy && "border-b border-borderColorOfMarket"
        }`}
      >
        <div
          className={`w-full  ${
            isFancy ? "md:col-span-6" : "md:col-span-5"
          }  col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]`}
        >
          <div
            className={` ${
              isFancy ? "col-span-10 md:col-span-11" : "truncate col-span-12"
            } flex items-start justify-center h-full flex-col`}
          >
            <div className=" w-full flex flex-nowrap gap-x-2">
              <span className=" truncate w-full capitalize text-text_Ternary  text-[13px] md:text-sm  font-semibold">
                {item?.fancy_name} {item?.category === 4 && "-"}{" "}
                {item?.category === 4 && item.LayPrice1}
              </span>
            </div>

            {renderExposureFancy(item?.selection_id)}
          </div>

          {isFancy ? (
            <>
              {!!betPlacing?.betDelay?.fancyBetDelay && (
                <span className=" col-span-2 md:col-span-1 pr-2 flex flex-row items-center justify-center gap-x-[2px]">
                  <svg
                    version={1.0}
                    height={15}
                    width={15}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 840.000000 936.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,936.000000) scale(0.100000,-0.100000)"
                      fill="#fff"
                      stroke="none"
                    >
                      <path d="M3472 8818 l3 -243 243 -3 242 -2 0 -244 0 -243 -122 -12 c-1359 -130 -2543 -950 -3143 -2176 -155 -318 -271 -677 -334 -1035 -75 -424 -73 -934 5 -1360 226 -1229 1014 -2267 2136 -2810 694 -335 1447 -455 2228 -354 567 74 1147 294 1640 624 792 530 1374 1353 1605 2270 133 529 156 1092 65 1627 -175 1029 -775 1959 -1645 2552 -539 367 -1135 586 -1792 657 l-163 18 0 243 0 243 243 2 242 3 3 243 2 242 -730 0 -730 0 2 -242z m1138 -1242 c478 -59 937 -216 1346 -463 765 -461 1323 -1208 1543 -2067 190 -738 131 -1502 -171 -2206 -175 -408 -460 -814 -789 -1122 -519 -487 -1138 -787 -1845 -895 -164 -25 -204 -27 -484 -27 -325 -1 -422 7 -685 60 -1170 231 -2155 1089 -2543 2214 -222 647 -250 1318 -82 1975 283 1104 1112 1999 2195 2372 215 74 531 144 735 162 63 6 133 13 155 15 85 9 506 -4 625 -18z" />
                      <path d="M3960 5620 c0 -654 -3 -1010 -10 -1010 -5 0 -41 -30 -80 -66 -51 -49 -80 -86 -105 -138 -133 -272 18 -605 310 -681 132 -34 277 -11 391 63 202 131 276 400 169 618 -25 52 -54 89 -105 138 -39 36 -75 66 -80 66 -7 0 -10 356 -10 1010 l0 1010 -240 0 -240 0 0 -1010z" />
                    </g>
                  </svg>
                  <span className=" font-[480] text-sm text-text_Ternary ">
                    {betPlacing?.betDelay?.fancyBetDelay}s
                  </span>
                </span>
              )}
              <span className=" col-span-2 md:col-span-1 flex flex-row items-center justify-center">
                <div
                  className={
                    openBets?.openBets?.some(
                      (myItem) => myItem.market_id == item?.fancy_id
                    )
                      ? " cursor-pointer "
                      : " opacity-50 cursor-not-allowed"
                  }
                  onClick={() => {
                    if (
                      openBets?.openBets?.some(
                        (myItem) => myItem.market_id == item?.fancy_id
                      )
                    ) {
                      openLadder(item?.fancy_name, item?.fancy_id);
                    }
                  }}
                >
                  <svg
                    height={18}
                    width={18}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="63d691358b4e4026f6539708_stairs 1">
                      <path
                        id="Vector"
                        d="M5.21875 3.13672V13.1367"
                        stroke="#fff"
                      />
                      <path
                        id="Vector_2"
                        d="M5.21875 5.48047H10.5312"
                        stroke="#fff"
                      />
                      <path
                        id="Vector_3"
                        d="M5.21875 8.13672H10.5312"
                        stroke="#fff"
                      />
                      <path
                        id="Vector_4"
                        d="M5.21875 11.1055H10.5312"
                        stroke="#fff"
                      />
                      <path
                        id="Vector_5"
                        d="M10.5312 3.13672V13.1367"
                        stroke="#fff"
                      />
                    </g>
                  </svg>
                </div>
              </span>
            </>
          ) : null}
        </div>

        <div
          className={` col-span-5 ${
            isFancy ? "md:col-span-6" : "md:col-span-7"
          }  h-12 grid grid-cols-2 md:grid-cols-6 relative`}
        >
          {status && !!status?.localeCompare("OPEN") ? (
            <span className=" col-span-4 text-center min-h-12 py-[1px] px-[1px]">
              <span className="  text-center bg-bg_ballRunning cursor-not-allowed w-full h-full rounded-sm flex text-xs flex-col items-center justify-center">
                {status?.toUpperCase()}
              </span>
            </span>
          ) : (
            <>{renderOdds(item, runner)}</>
          )}
          {isFancy && (
            <span className=" hidden md:block col-span-2 text-center min-h-12">
              <div className=" flex flex-col gap-y-1 items-center h-full w-full  justify-center  px-1">
                <div className=" flex items-center justify-center">
                  <span className=" text-[10px] text-center  text-text_MaxMarketTextColor">
                    Min Bet :
                  </span>
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                    {" "}
                    {getCurrencyFormat(
                      data?.session_live_odds_validation
                        ? data?.Min
                        : sportLimits?.check_event_limit
                        ? sportLimits?.data?.session &&
                          sportLimits?.data?.session[data?.fancy_id]
                            ?.session_min_stack
                        : sportLimits?.data?.session?.session_min_stack
                    )}
                  </span>
                </div>

                <div className=" flex items-center justify-start">
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor ">
                    Max Bet :
                  </span>
                  <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                    {" "}
                    {getCurrencyFormat(
                      data?.session_live_odds_validation
                        ? data?.Max
                        : sportLimits?.check_event_limit
                        ? sportLimits?.data?.session &&
                          sportLimits?.data?.session[data?.fancy_id]
                            ?.session_max_stack
                        : sportLimits?.data?.session?.session_max_stack
                    )}
                  </span>
                </div>
              </div>
            </span>
          )}
        </div>

        <div className="col-span-12 h-max">
          {width < 1024 &&
            (isFancy
              ? betPlacing.market == item?.fancy_id
              : betPlacing.market == data?.marketId) &&
            status &&
            (isFancy || betPlacing.runner == runner.id) &&
            !status.localeCompare("OPEN") && (
              <span className=" col-span-12 h-max w-full">
                <BetPlacing onClose={() => {}} />
              </span>
            )}
        </div>
      </div>
    );
  };

  return (
    <div className={"py-1.5"}>
      {showHeader && !isFancy && (
        <div className=" grid grid-flow-col grid-cols-12  text-xs font-[500] mb-1.5">
          <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5 ">
            <span className=" cursor-pointer transition-all ease-in-out duration-300 hover:scale-105"></span>
            <span className={` capitalize  font-bold ${UNICON_THEME? "text-black": "text-white"}  text-xs sm:text-sm md:text-[15px]`}>
              {data?.market_name}
            </span>

            {data?.runners?.length <= 2 &&
              data?.market_type === "MATCH_ODDS" && (
                <button
                  className=" leading-normal relative overflow-hidden  transition duration-150 ease-in-out bg-cashout-btn-gradient rounded-md px-2.5 py-1.5 text-center shadow-[inset_-12px_-8px_40px_#46464620] flex items-center justify-center flex-row h-max  max-w-[74%] mr-1 cursor-pointer"
                  type="button"
                  style={
                    cashOutData != 0
                      ? {
                          backgroundImage:
                            "linear-gradient(90deg, #ef8402, #ef8402)",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (
                      openBets?.openBets?.some(
                        (item) => item.market_id === data.market_id
                      )
                    ) {
                      sendCahsOutRequest(data, data.betDelay);
                    }
                  }}
                >
                  <div className="text-[10px] md:text-sm text-text_Quaternary whitespace-nowrap  font-semibold flex">
                    Cashout{" "}
                    {cashOutData != 0 && (
                      <div className="capitalize text-[10px] md:text-sm ml-1 text-text_color_primary2 whitespace-nowrap  font-semibold">
                        <span> : </span>
                        <span className="font-roboto">₹ </span>
                        <span>{cashOutData.toFixed(2)}</span>
                      </div>
                    )}
                  </div>
                </button>
              )}
          </div>

          <div className=" col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
            <span className=" hidden md:flex col-span-1 text-center  font-semibold h-full  items-end justify-center"></span>
            <span className=" col-span-1 text-center  font-semibold h-full  hidden md:flex  items-end justify-center"></span>
            <span className={` col-span-1 ${UNICON_THEME? "text-black": "text-white"} text-center text-[10px] sm:text-xs md:text-sm leading-3 text-text_Ternary   font-bold h-full flex items-end justify-center`}>
              BACK
            </span>
            <span className={` col-span-1 ${UNICON_THEME? "text-black": "text-white"} text-center text-[10px] sm:text-xs md:text-sm  leading-3   font-bold h-full flex items-end justify-center`}>
              LAY
            </span>
            <span className=" col-span-1 text-center font-semibold  h-full  hidden md:flex  items-end justify-center"></span>
            <span className=" col-span-1 text-center font-semibold  h-full  hidden md:flex  items-end justify-center"></span>
          </div>
        </div>
      )}

      <>
        <div className=" bg-bg_Quaternary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px] cursor-pointer">
          {!isFancy &&
            data?.runners?.map((item, itemIndex) => {
              const runner = {
                id: !isFancy
                  ? !!item?.selectionId
                    ? item?.selectionId
                    : Array.isArray(data?.runners)
                    ? data?.runners[itemIndex]?.selectionId
                    : ""
                  : item?.fancy_id,
                name: !isFancy
                  ? !!item?.selection_name
                    ? item?.selection_name
                    : Array.isArray(data?.runners)
                    ? data?.runners[itemIndex]?.runnerName
                    : ""
                  : item?.fancy_name,
                status: !isFancy
                  ? item?.status != "ACTIVE" || data?.status != "OPEN"
                    ? "SUSPENDED"
                    : "OPEN"
                  : item?.status,
              };

              const status = isFancy ? item?.status : data?.status;

              return (
                <div
                  key={`${item?.id}-${itemIndex}`}
                  id={item?.id}
                  className={`grid grid-cols-12  ${
                    itemIndex != data?.runners?.length - 1 &&
                    "border-b border-borderColorOfMarket"
                  }`}
                >
                  <div
                    className={`w-full  ${
                      isFancy ? "md:col-span-6" : "md:col-span-5"
                    }  col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]`}
                  >
                    <div
                      className={` ${
                        isFancy
                          ? "col-span-8 md:col-span-10"
                          : "truncate col-span-12"
                      } flex items-start justify-center h-full flex-col`}
                    >
                      <div className=" w-full flex flex-nowrap gap-x-2">
                        {data.sport_id == 7 && (
                          <div
                            onClick={() => addMarketData(item)}
                            className={
                              !selectedRaces.some(
                                (itemSelect) =>
                                  itemSelect.selectionId === item.selectionId
                              )
                                ? "topFilters-item-check"
                                : "topFilters-item-check checked"
                            }
                          ></div>
                        )}

                        {data.sport_id == 7 && (
                          <div className="col-span-2 flex items-center justify-center gap-y-[0.5px] flex-col text-text_color_primary1">
                            <span className="text-xs font-[400]">
                              {itemIndex + 1}
                            </span>
                            {data?.runners[itemIndex]?.metadata
                              ?.CLOTH_NUMBER && (
                              <span className="text-xs font-[400]">
                                (
                                {
                                  data?.runners[itemIndex]?.metadata
                                    ?.CLOTH_NUMBER
                                }
                                )
                              </span>
                            )}
                          </div>
                        )}

                        {isRacing &&
                          data?.runners[itemIndex]?.metadata
                            ?.COLOURS_FILENAME && (
                            <div className="relative overflow-hidden  w-[20px] h-[20px] mr-[6px] col-span-3">
                              <img
                                src={
                                  data?.runners[itemIndex]?.metadata
                                    ?.COLOURS_FILENAME
                                }
                                alt="Obed Sanchez"
                                sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 625px"
                                className=" bg-bg_color_skeletonBgLoaderColor1 w-[20px] h-[20px]"
                                title="Obed Sanchez"
                              />
                            </div>
                          )}

                        {isRacing && data?.runners[itemIndex]?.metadata ? (
                          <div className="col-span-7 w-full flex flex-col text-text_color_primary1">
                            <div className="w-full text-xs md:text-sm font-[400]">
                              {data?.runners[itemIndex]?.metadata
                                ?.JOCKEY_NAME ||
                                item?.selection_name ||
                                data?.runners[itemIndex]?.runnerName ||
                                data?.competitionName}
                            </div>
                            <span className="text-[10px]">
                              {data?.runners[itemIndex]?.metadata?.TRAINER_NAME}
                            </span>
                          </div>
                        ) : (
                          <span className=" truncate w-full capitalize text-text_Ternary  text-[13px] md:text-sm  font-semibold">
                            {isFancy
                              ? item?.marketName
                              : isRacing
                              ? data?.runners[itemIndex]?.metadata
                                ? data?.runners[itemIndex]?.metadata
                                    ?.JOCKEY_NAME
                                : item?.selection_name ||
                                  data?.runners[itemIndex]?.runnerName ||
                                  data?.competitionName
                              : item?.selection_name ||
                                data?.runners[itemIndex]?.runnerName ||
                                data?.competitionName}
                          </span>
                        )}
                      </div>

                      {renderExposure(runner?.id, item, itemIndex)}
                    </div>

                    {isFancy ? (
                      <>
                        {!!betPlacing?.betDelay?.fancyBetDelay && (
                          <span className=" col-span-2 md:col-span-1 pr-2 flex flex-row items-center justify-center gap-x-[2px]">
                            <svg
                              version={1.0}
                              height={15}
                              width={15}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 840.000000 936.000000"
                              preserveAspectRatio="xMidYMid meet"
                            >
                              <g
                                transform="translate(0.000000,936.000000) scale(0.100000,-0.100000)"
                                fill="#fff"
                                stroke="none"
                              >
                                <path d="M3472 8818 l3 -243 243 -3 242 -2 0 -244 0 -243 -122 -12 c-1359 -130 -2543 -950 -3143 -2176 -155 -318 -271 -677 -334 -1035 -75 -424 -73 -934 5 -1360 226 -1229 1014 -2267 2136 -2810 694 -335 1447 -455 2228 -354 567 74 1147 294 1640 624 792 530 1374 1353 1605 2270 133 529 156 1092 65 1627 -175 1029 -775 1959 -1645 2552 -539 367 -1135 586 -1792 657 l-163 18 0 243 0 243 243 2 242 3 3 243 2 242 -730 0 -730 0 2 -242z m1138 -1242 c478 -59 937 -216 1346 -463 765 -461 1323 -1208 1543 -2067 190 -738 131 -1502 -171 -2206 -175 -408 -460 -814 -789 -1122 -519 -487 -1138 -787 -1845 -895 -164 -25 -204 -27 -484 -27 -325 -1 -422 7 -685 60 -1170 231 -2155 1089 -2543 2214 -222 647 -250 1318 -82 1975 283 1104 1112 1999 2195 2372 215 74 531 144 735 162 63 6 133 13 155 15 85 9 506 -4 625 -18z" />
                                <path d="M3960 5620 c0 -654 -3 -1010 -10 -1010 -5 0 -41 -30 -80 -66 -51 -49 -80 -86 -105 -138 -133 -272 18 -605 310 -681 132 -34 277 -11 391 63 202 131 276 400 169 618 -25 52 -54 89 -105 138 -39 36 -75 66 -80 66 -7 0 -10 356 -10 1010 l0 1010 -240 0 -240 0 0 -1010z" />
                              </g>
                            </svg>
                            <span className=" font-[480] text-sm text-text_Ternary ">
                              {betPlacing?.betDelay?.fancyBetDelay}s
                            </span>
                          </span>
                        )}
                        <span className=" col-span-2 md:col-span-1 flex flex-row items-center justify-center">
                          <div
                            className={
                              openBets?.openBets?.some(
                                (myItem) => myItem.market_id == item?.market_id
                              )
                                ? " cursor-pointer "
                                : " opacity-50 cursor-not-allowed"
                            }
                            onClick={() => {
                              if (
                                openBets?.openBets?.some(
                                  (myItem) =>
                                    myItem.market_id == item?.market_id
                                )
                              ) {
                                openLadder(item);
                              }
                            }}
                          >
                            <svg
                              height={18}
                              width={18}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="63d691358b4e4026f6539708_stairs 1">
                                <path
                                  id="Vector"
                                  d="M5.21875 3.13672V13.1367"
                                  stroke="#fff"
                                />
                                <path
                                  id="Vector_2"
                                  d="M5.21875 5.48047H10.5312"
                                  stroke="#fff"
                                />
                                <path
                                  id="Vector_3"
                                  d="M5.21875 8.13672H10.5312"
                                  stroke="#fff"
                                />
                                <path
                                  id="Vector_4"
                                  d="M5.21875 11.1055H10.5312"
                                  stroke="#fff"
                                />
                                <path
                                  id="Vector_5"
                                  d="M10.5312 3.13672V13.1367"
                                  stroke="#fff"
                                />
                              </g>
                            </svg>
                          </div>
                        </span>
                      </>
                    ) : null}
                  </div>

                  <div
                    className={` col-span-5 ${
                      isFancy ? "md:col-span-6" : "md:col-span-7"
                    }  h-12 grid grid-cols-2 md:grid-cols-6 relative`}
                  >
                    {renderOdds(item, runner)}

                    {isFancy && (
                      <span className=" hidden md:block col-span-2 text-center min-h-12">
                        <div className=" flex flex-col gap-y-1 items-center h-full w-full  justify-center  px-1">
                          <div className=" flex items-center justify-center">
                            <span className=" text-[10px] text-center  text-text_MaxMarketTextColor">
                              Min Bet :
                            </span>
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                              {" "}
                              {getCurrencyFormat(
                                data?.session_live_odds_validation
                                  ? data?.Min
                                  : sportLimits?.check_event_limit
                                  ? sportLimits?.data?.session[data?.fancy_id]
                                      ?.session_min_stack
                                  : sportLimits?.data?.session
                                      ?.session_min_stack
                              )}
                            </span>
                          </div>

                          <div className=" flex items-center justify-start">
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor ">
                              Max Bet :
                            </span>
                            <span className=" text-[10px] text-center text-text_MaxMarketTextColor">
                              {" "}
                              {getCurrencyFormat(
                                data?.session_live_odds_validation
                                  ? data?.Max
                                  : sportLimits?.check_event_limit
                                  ? sportLimits?.data?.session[data?.fancy_id]
                                      ?.session_max_stack
                                  : sportLimits?.data?.session
                                      ?.session_max_stack
                              )}
                            </span>
                          </div>
                        </div>
                      </span>
                    )}
                  </div>

                  <div className="col-span-12 h-max">
                    {width < 1024 &&
                      (isFancy
                        ? betPlacing.market == item?.fancy_id
                        : betPlacing.market == data?.market_id) &&
                      status &&
                      (isFancy || betPlacing.runner == runner.id) &&
                      !status.localeCompare("OPEN") &&
                      !cashoutPopUp?.isOpen && (
                        <span className=" col-span-12 h-max w-full">
                          <BetPlacing onClose={() => {}} />
                        </span>
                      )}
                  </div>
                </div>
              );
            })}

          {isFancy && data && renderFancy(data)}
        </div>
      </>
    </div>
  );
};

export default connectSportMarketStandard()(SportMarketStandard);
